<div class="menu-bar">
  <div class="menu-bar-content">
    <div class="top-content">
      <div class="logo-wrapper mb-2">
        <img
          src="/img/logo-without-slogan.png"
          alt="Sanactivo Logo"
          class="ms-2 me-2"
          routerLink="/" />
      </div>

      <div class="menu-entries">
        <a
          class="menu-entry"
          [routerLink]="['/']">
          <i class="pi pi-home"></i>
          Home
        </a>

        <a
          [routerLink]="['/']"
          class="menu-entry">
          <i class="pi pi-search"></i>
          Patient suchen
        </a>

        <a
          [routerLink]="['/client/add']"
          class="menu-entry">
          <i class="pi pi-plus-circle"></i>
          Patient anlegen
        </a>
      </div>
    </div>

    <div class="bottom-content">
      <div class="menu-entries">
        <div class="menu-separator"></div>

       <!-- <a
          class="menu-entry"
          [routerLink]="['/profile']">
          <i class="pi pi-user"></i>
          Mein Profil
        </a>-->

        <a
          class="menu-entry"
          [routerLink]="['/subscription']">
          <i class="pi pi-credit-card"></i>
          Abo
        </a>

        <!-- ToDo: collapse button -->
        <div
          role="button"
          class="menu-entry"
          (click)="logout()">
          <i class="pi pi-power-off"></i>
          Logout
        </div>
      </div>
    </div>
  </div>
</div>

